export default __webpack_public_path__ + "static/media/Online learning-amico (1).c22eb5bc.svg";